
/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setDeviceSearch, resetDeviceSearch } from '../../../redux/deviceSearchSlice'; // Update with your actual slice import
import { useSearchParams } from 'react-router-dom';
import AdvancedSearchInputBox from '../../AdvancedSearchInput/AdvancedSearchInputBox';
import DateInput from '../../DateField';
import GlobalContext from '../../Context/GloablContext';
import DateInputStatic from '../../DateField/staticdate';

export default function DeviceAdvanceSearch({handleOnSubmit,emptyField,setEmptyField}) {
    const dispatch = useDispatch();
    const deviceSearch = useSelector(state => state.deviceSearchData); // Select deviceSearch from Redux
    const { isAdvancedSearchOpen, setIsAdvancedSearchOpen, isSideBar, setIsSideBar } = useContext(GlobalContext);
    const [searchParams, setSearchParams] = useSearchParams();
    const searchApplied = useSelector((state) => state.deviceSearchData.searchApplied);

    const sidebarPrvState = useSelector(state => state.systemConfigData.sidebarPrvState);

    /**
     * The function `handleOnChangeUserDetails` updates the device search state based on the provided
     * id and value, with additional handling for checkboxes.
     */
    const handleOnChangeUserDetails = (id, value) => {
        // Trim value if it's a string
        const updatedValue = typeof value === 'string' ? value : value;
        // Create an updated deviceSearch state
        const updatedState = {
            ...deviceSearch,
            [id]: updatedValue,
        };
        // Default handling for other fields (uncheck checkbox if input is cleared)
        if (updatedValue === '' && deviceSearch[`${id}_inverse`] === 'true') {
            updatedState[`${id}_inverse`] = '';
        }
        // Dispatch updated state to Redux
        dispatch(setDeviceSearch(updatedState));
    };

    // handleSelect checkbox functions
    const handleCheckboxChange = (e, field) => {
        const { checked } = e.target;

        // Create an updated deviceSearch state
        const updatedState = { ...deviceSearch, [field]: checked ? 'true' : '' };

        // Dispatch the updated state
        dispatch(setDeviceSearch(updatedState));
    };

    const dateformatSysconfig = useSelector((state) => state.systemConfigData.globalVariables.date_format);
    const [dateFormat, setDateFormat] = useState('dd/mm/yyyy');

    // Update date format from sysconfig
    useEffect(() => {
        if (dateformatSysconfig) {
            const format = dateformatSysconfig.split(',')[0].toLowerCase();
            setDateFormat(format === 'mm/dd/yyyy' ? 'mm/dd/yyyy' : 'dd/mm/yyyy');
        }
    }, [dateformatSysconfig]);

    /**
    * The handleDateChange function validates and updates date fields in a React application, allowing
    * for flexible input formats and clearing the date if all fields are empty.
    */
    const handleDateChange = (newDate) => {
        setEmptyField(false);
        // Allow any combination of numbers and dashes in each field, and apply limits only if no dash is present
        const validatedDay = /^[-0-9]*$/.test(newDate.day) && 
            (newDate.day.includes('-') || (newDate.day.length <= 2 && parseInt(newDate.day) <= 31)) 
            ? newDate.day 
            : '';
    
        const validatedMonth = /^[-0-9]*$/.test(newDate.month) && 
            (newDate.month.includes('-') || (newDate.month.length <= 2 && parseInt(newDate.month) <= 12)) 
            ? newDate.month 
            : '';
    
        const validatedYear = /^[-0-9]*$/.test(newDate.year) && 
            (newDate.year.includes('-') || newDate.year.length <= 4) 
            ? newDate.year 
            : '';
    
        // Check if the date is fully cleared
        const isDateCleared = !validatedDay.trim() && !validatedMonth.trim() && !validatedYear.trim();
    
        dispatch(setDeviceSearch({
            ...deviceSearch,
            assigned_day: validatedDay,
            assigned_month: validatedMonth,
            assigned_year: validatedYear,
            assigned_at_inverse: isDateCleared ? '' : deviceSearch.assigned_at_inverse,
        }));
    };
    
    
    /**
     * The function `handleDateChangeInitialReading` validates and updates date components in a React
     * application's state based on user input.
     */
    const handleDateChangeInitialReading = (newDate) => {
        const validatedinitialDay = /^[-0-9]*$/.test(newDate.day) && 
                                    (newDate.day.includes('-') || (newDate.day.length <= 2 && parseInt(newDate.day) <= 31)) 
            ? newDate.day 
            : '';
    
        const validatedinitialMonth = /^[-0-9]*$/.test(newDate.month) && 
                                      (newDate.month.includes('-') || (newDate.month.length <= 2 && parseInt(newDate.month) <= 12)) 
            ? newDate.month 
            : '';
    
        const validatedinitialYear = /^[-0-9]*$/.test(newDate.year) && 
                                     (newDate.year.includes('-') || newDate.year.length <= 4) 
            ? newDate.year 
            : '';
    
        const isDateCleared = !validatedinitialDay.trim() && !validatedinitialMonth.trim() && !validatedinitialYear.trim();
    
        dispatch(setDeviceSearch({
            ...deviceSearch,
            initial_reading_day: validatedinitialDay,
            initial_reading_month: validatedinitialMonth,
            initial_reading_year: validatedinitialYear,
            initial_reading_inverse: isDateCleared ? '' : deviceSearch.initial_reading_inverse,
        }));
    };
    
    /**
     * The function `handleDateChangePurchaseDate` validates and updates purchase date information in a
     * React application.
     */
    const handleDateChangePurchaseDate = (newDate) => {
        const validatedpurchaseDay = /^[-0-9]*$/.test(newDate.day) && 
                                     (newDate.day.includes('-') || (newDate.day.length <= 2 && parseInt(newDate.day) <= 31)) 
            ? newDate.day 
            : '';
    
        const validatedpurchaseMonth = /^[-0-9]*$/.test(newDate.month) && 
                                       (newDate.month.includes('-') || (newDate.month.length <= 2 && parseInt(newDate.month) <= 12)) 
            ? newDate.month 
            : '';
    
        const validatedpurchaseYear = /^[-0-9]*$/.test(newDate.year) && 
                                      (newDate.year.includes('-') || newDate.year.length <= 4) 
            ? newDate.year 
            : '';
    
        const isDateCleared = !validatedpurchaseDay.trim() && !validatedpurchaseMonth.trim() && !validatedpurchaseYear.trim();
    
        dispatch(setDeviceSearch({
            ...deviceSearch,
            purchase_date_day: validatedpurchaseDay,
            purchase_date_month: validatedpurchaseMonth,
            purchase_date_year: validatedpurchaseYear,
            purchase_date_inverse: isDateCleared ? '' : deviceSearch.purchase_date_inverse,
        }));
    };
    
    /**
     * The function `handleDateChangeServiceActivation` validates and updates service activation date
     * fields in a React application.
     */
    const handleDateChangeServiceActivation = (newDate) => {
        const validatedserviceactivationDay = /^[-0-9]*$/.test(newDate.day) && 
                                              (newDate.day.includes('-') || (newDate.day.length <= 2 && parseInt(newDate.day) <= 31)) 
            ? newDate.day 
            : '';
    
        const validatedserviceactivationMonth = /^[-0-9]*$/.test(newDate.month) && 
                                                (newDate.month.includes('-') || (newDate.month.length <= 2 && parseInt(newDate.month) <= 12)) 
            ? newDate.month 
            : '';
    
        const validatedserviceactivationYear = /^[-0-9]*$/.test(newDate.year) && 
                                               (newDate.year.includes('-') || newDate.year.length <= 4) 
            ? newDate.year 
            : '';
    
        const isDateCleared = !validatedserviceactivationDay.trim() && !validatedserviceactivationMonth.trim() && !validatedserviceactivationYear.trim();
    
        dispatch(setDeviceSearch({
            ...deviceSearch,
            service_activation_date_day: validatedserviceactivationDay,
            service_activation_date_month: validatedserviceactivationMonth,
            service_activation_date_year: validatedserviceactivationYear,
            service_activation_date_inverse: isDateCleared ? '' : deviceSearch.service_activation_date_inverse,
        }));
    };
    
    
    // Function to handle button click
    const handleCloseClick = () => {
        // Toggle the advanced search state
        setIsAdvancedSearchOpen(!isAdvancedSearchOpen);
        // If previous sidebar state was true and isSideBar is currently false, set it to true
        if (sidebarPrvState === true && !isSideBar) {
            setIsSideBar(true);
        }
        // Reset search state if searchApplied is false
        if (!searchApplied) {
            dispatch(resetDeviceSearch());
        }
    };

    /**
     * The function `isApplyButtonDisabled` checks if all values in the `deviceSearch` object are
     * considered empty based on their type.
     * @returns The function `isApplyButtonDisabled` is returning a boolean value. It checks all
     * key-value pairs in the `deviceSearch` object and returns `true` if all conditions are met for
     * each value to be considered as 'empty'.
     */
    const isApplyButtonDisabled = () => {
        return Object.entries(deviceSearch).every(([key, value]) => {
            if (key === 'match') return true; // Ignore 'match'
    
            // Check if value is an array
            if (Array.isArray(value)) {
                return value.length === 0; // Return true if the array is empty
            }
    
            // Check if value is a string
            if (typeof value === 'string') {
                return value.trim() === ''; // Trim and check if it's empty
            }
    
            // For any other type (objects, numbers, etc.), return true to indicate it's 'empty'
            return true;
        });
    };

    /*** The `handleClearAll` function resets parameters and clears search-related fields.*/
    const handleClearAll = () => {
        dispatch(resetDeviceSearch());
        const updatedParams = new URLSearchParams(searchParams);
        updatedParams.delete('search');
        updatedParams.delete('search_mode');
        setTimeout(()=>{
            setSearchParams(Object.fromEntries(updatedParams.entries()));
            setEmptyField(false);
        },300)

    };

    /* The above code is using the `useEffect` hook in a React component to add an event listener for
    the "keydown" event on the window object. When a key is pressed, it checks if the key pressed is
    the "Escape" key, and if so, it calls the `handleClearAll` function. The `useEffect` hook also
    includes a cleanup function that removes the event listener when the component unmounts. */
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                handleClearAll();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    /* The above code is a `useEffect` hook in a React component. It is triggered when the
    `isAdvancedSearchOpen` dependency changes. */
    useEffect(() => {
        dispatch(resetDeviceSearch())
        const params = Object.fromEntries(searchParams);
           
        if (params.search) {
            // Decode the search string to get individual fields
            const searchDecoded = decodeURIComponent(params.search);
           
            // Existing matches for user_id, first_name, last_name and other states
            const deviceIdMatch = searchDecoded.match(/device_id=(ne:)?(.+?)(;|$)/);
            const serialNumberMatch = searchDecoded.match(/serial_number=(ne:)?(.+?)(;|$)/);
            const apiIdentifierMatch = searchDecoded.match(/api_identifier=(ne:)?(.+?)(;|$)/);
            const manufName = searchDecoded.match(/manufacturer_name=(ne:)?(.+?)(;|$)/);
            const model = searchDecoded.match(/model=(ne:)?(.+?)(;|$)/);
            const patientId = searchDecoded.match(/patient_id=(ne:)?(.+?)(;|$)/);
            const serviceProviderMatch = searchDecoded.match(/service_provider=(ne:)?(.+?)(;|$)/);  
            const servicePeriodMatch = searchDecoded.match(/service_period=(ne:)?(.+?)(;|$)/);
            const warrantyPeriodMatch = searchDecoded.match(/warranty_period=(ne:)?(.+?)(;|$)/);
            const descriptionMatch = searchDecoded.match(/description=(ne:)?(.+?)(;|$)/);
            const assignedDateMatch = searchDecoded.match(/assigned_at=(ne:)?(\d+)(;|$)/);
            const initialReadingDateMatch = searchDecoded.match(/initial_reading_timestamp=(ne:)?(\d+)(;|$)/);
            const purchaseDateMatch = searchDecoded.match(/purchase_date_str=(ne:)?(.+?)(;|$)/);
            const serviceActivationDateMatch = searchDecoded.match(/service_activation_date_str=(ne:)?(.+?)(;|$)/);

    
           
            // Build the new state
            const updatedState = {};
           
            // handle device_id field
            if (deviceIdMatch) {
                const isInverse = !!deviceIdMatch[1]; 
                const tempIdValue = deviceIdMatch[2]; 
           
                updatedState.device_id = tempIdValue === '__NULL__' ? '-' : tempIdValue;
                updatedState.device_id_inverse = isInverse ? 'true' : '';
            }
                    
            // Handle serial_number field
            if (serialNumberMatch) {
                const isInverse = !!serialNumberMatch[1];
                const serialNOValue = serialNumberMatch[2];
                updatedState.serial_number = serialNOValue === '__NULL__' ? '-' : serialNOValue;
                updatedState.serial_number_inverse = isInverse ? 'true' : '';
            }

            // Handle api_identifier field
            if (apiIdentifierMatch) {
                const isInverse = !!apiIdentifierMatch[1];
                const apiIdentifierValue = apiIdentifierMatch[2];
                updatedState.api_identifier = apiIdentifierValue === '__NULL__' ? '-' : apiIdentifierValue;
                updatedState.api_identifier_inverse = isInverse ? 'true' : '';
            }

            // Handle manufacturer_name field
            if (manufName) {
                const isInverse = !!manufName[1];
                const manNameValue = manufName[2];
                updatedState.manufacturer_name = manNameValue === '__NULL__' ? '-' : manNameValue;
                updatedState.manufacturer_name_inverse = isInverse ? 'true' : '';
            }
    
            // Handle model field
            if (model) {
                const isInverse = !!model[1];
                const modelValue = model[2];
                updatedState.model = modelValue === '__NULL__' ? '-' : modelValue;
                updatedState.model_inverse = isInverse ? 'true' : '';
            }
    
            // Handle model field
            if (patientId) {
                const isInverse = !!patientId[1];
                const patientIdValue = patientId[2];
                updatedState.patient_id = patientIdValue === '__NULL__' ? '-' : patientIdValue;
                updatedState.patient_id_inverse = isInverse ? 'true' : '';
            }

            // Handle serviceProviderMatch field
            if (serviceProviderMatch) {
                const isInverse = !!serviceProviderMatch[1];
                const serviceProviderMatchValue = serviceProviderMatch[2];
                updatedState.service_provider = serviceProviderMatchValue === '__NULL__' ? '-' : serviceProviderMatchValue;
                updatedState.service_provider_inverse = isInverse ? 'true' : '';
            }

            // Handle servicePeriodMatch field
            if (servicePeriodMatch) {
                const isInverse = !!servicePeriodMatch[1];
                const servicePeriodMatchValue = servicePeriodMatch[2];
                updatedState.service_period = servicePeriodMatchValue === '__NULL__' ? '-' : servicePeriodMatchValue;
                updatedState.service_period_inverse = isInverse ? 'true' : '';
            }

            // Handle warranty_period field
            if (warrantyPeriodMatch) {
                const isInverse = !!warrantyPeriodMatch[1];
                const warrantyPeriodMatchValue = warrantyPeriodMatch[2];
                updatedState.warranty_period = warrantyPeriodMatchValue === '__NULL__' ? '-' : warrantyPeriodMatchValue;
                updatedState.warranty_period_inverse = isInverse ? 'true' : '';
            }

            // Handle description field
            if (descriptionMatch) {
                const isInverse = !!descriptionMatch[1];
                const descriptionMatchValue = descriptionMatch[2];
                updatedState.description = descriptionMatchValue === '__NULL__' ? '-' : descriptionMatchValue;
                updatedState.description_inverse = isInverse ? 'true' : '';
            }

    
            // Handle assigned date field
            if (assignedDateMatch) {
                const isInverse = !!assignedDateMatch[1]; 
                const epochTime = assignedDateMatch[2]; 
                    
                // Convert epoch time to a date
                const date = new Date(parseInt(epochTime, 10) * 1000); 
                    
                // Use getDate(), getMonth(), and getFullYear() for local time
                const day = date.getDate().toString().padStart(2, '0'); // Ensure day is two digits
                const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensure month is two digits
                const year = date.getFullYear().toString(); 
                    
                // Update state with the correct date and inverse flag
                updatedState.assigned_day = day;
                updatedState.assigned_month = month;
                updatedState.assigned_year = year;
                updatedState.assigned_at_inverse = isInverse ? 'true' : ''; 
            }
    
            // Handle initial reading date field
            if (initialReadingDateMatch) {
                const isInverse = !!initialReadingDateMatch[1]; 
                const epochTime = initialReadingDateMatch[2]; 
                    
                // Convert epoch time to a date
                const date = new Date(parseInt(epochTime, 10) * 1000); 
                    
                // Use getDate(), getMonth(), and getFullYear() for local time
                const day = date.getDate().toString().padStart(2, '0'); // Ensure day is two digits
                const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensure month is two digits
                const year = date.getFullYear().toString(); 
    
                // Update state with the correct date and inverse flag
                updatedState.initial_reading_day = day;
                updatedState.initial_reading_month = month;
                updatedState.initial_reading_year = year;
                updatedState.initial_reading_inverse = isInverse ? 'true' : ''; 
            }

            // Handle purchase_date_str
            if (purchaseDateMatch) {
                const isInverse = !!purchaseDateMatch[1];
                const purchaseDateValue = purchaseDateMatch[2];
            
                if (purchaseDateValue !== '__NULL__') {
                    const [month, day, year] = purchaseDateValue.split('/');
                    updatedState.purchase_date_day = day;
                    updatedState.purchase_date_month = month;
                    updatedState.purchase_date_year = year;
                } else {
                    updatedState.purchase_date_day = '--';
                    updatedState.purchase_date_month = '--';
                    updatedState.purchase_date_year = '----';
                }

                updatedState.purchase_date_inverse = isInverse ? 'true' : '';
            }

            // Handle service_activation_date_str
            if (serviceActivationDateMatch) {
                const isInverse = !!serviceActivationDateMatch[1];
                const serviceActivationDateValue = serviceActivationDateMatch[2];
            
                if (serviceActivationDateValue !== '__NULL__') {
                    const [month, day, year] = serviceActivationDateValue.split('/');
                    updatedState.service_activation_date_day = day;
                    updatedState.service_activation_date_month = month;
                    updatedState.service_activation_date_year = year;
                } else {
                    updatedState.service_activation_date_day = '--';
                    updatedState.service_activation_date_month = '--';
                    updatedState.service_activation_date_year = '----';
                }

                updatedState.service_activation_date_inverse = isInverse ? 'true' : '';
            }
                    
            // Handle search_mode if applicable
            if (params.search_mode) {
                updatedState.match = params.search_mode === 'or' ? true : false;
            }
           
            // Dispatch the action to update Redux state
            setTimeout(() => {
                dispatch(setDeviceSearch(updatedState));
            }, 0);
        }
    }, [isAdvancedSearchOpen]);
    

    return (
        <div className='absolute top-0 left-0 w-[267px] rounded-tr-[12px] rounded-br-[12px] shadow-s7 h-[100dvh] bg-[#ffffff] z-[100]'>
            <form action='' 
                onSubmit={(e) => handleOnSubmit(e)} // Existing submit handler
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault(); 
                        handleOnSubmit(e);
                    }
                }}
                className='w-full px-3 py-4'>
                <section className='flex justify-between items-center'>
                    <p className='text-sm font-semibold text-[#52555D]'>Advanced Search</p>
                    <button onClick={handleCloseClick}>
                        <img src="/images/cross_mark_gray.svg" alt="close-icon" loading='lazy' decoding='async' />
                    </button>
                </section>
                <section className='mt-4 flex items-center pb-4 border-b border-[#C5C9DA]'>
                    <p className='text-xs font-normal text-[#000000] pr-2'>Match:</p>
                    <div className='flex items-center'>
                        <div className='flex items-center'>
                            <div className="relative custom-radioBlue flex items-center">
                                <input id="match_any" type="radio" name="default-radio1" checked={deviceSearch?.match} onChange={()=>handleOnChangeUserDetails("match",true)}/>
                                <label htmlFor="match_any" className={`text-xs font-normal ${deviceSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    Any
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match any of the input values. <br />
                                    Example: A OR B will return results that match either A, B, or both.
                                </p>
                            </div>
                        </div>
                        <div className='flex items-center ml-4'>
                            <div className="relative custom-radioBlue flex items-center ml-3" >
                                <input id="match_all"  type="radio" name="default-radio1" checked={!deviceSearch?.match} onChange={()=>handleOnChangeUserDetails("match",false)}/>
                                <label htmlFor="match_all" className={`text-xs font-normal ${!deviceSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    All 
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match all of the input values. <br />
                                    Example: A AND B will only return results that match both A and B.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {emptyField && 
                    <p className='text-xs font-normal text-[#c52828] my-1 text-center'>Please fill the date field completely</p>
                }
                <div className='w-full flex items-center my-3'>
                    <div className='w-[170px] mr-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Column Name & Value</p>
                    </div>
                    <div className='relative w-[65px] flex items-center'>
                        <p className='text-xs font-normal text-[#52555D]'>Inverse</p>
                        <span className='any_hover z-[99] ml-1'>
                            <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                        </span>
                        <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[10]'>
                            Excludes results that match the input value. <br />
                            Example: NOT A will return all results except those that match A.
                        </p>
                    </div>
                </div>
                <div className='-ml-2'>
                    <div className={`overflow-auto pl-2 ${emptyField?'h-[calc(100dvh-300px)]':'h-[calc(100dvh-285px)]'} scrollbar_purple`}>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"ID"}
                                    placeholder={"Enter ID"}
                                    id={"device_id"}
                                    data_testid={"device_id"}
                                    htmlFor={"device_id"}
                                    value={deviceSearch.device_id}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={15}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='device_id_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'device_id_inverse')}
                                        checked={deviceSearch.device_id_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceSearch?.device_id?.trim()===""}
                                    />
                                    <label htmlFor='device_id_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Manufacturer"}
                                    placeholder={"Enter manufacturer"}
                                    id={"manufacturer_name"}
                                    data_testid={"manufacturer_name"}
                                    htmlFor={"manufacturer_name"}
                                    value={deviceSearch?.manufacturer_name}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='manufacturer_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'manufacturer_name_inverse')}
                                        checked={deviceSearch?.manufacturer_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceSearch?.manufacturer_name?.trim()===""}
                                    />
                                    <label htmlFor='manufacturer_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Model"}
                                    placeholder={"Enter model"}
                                    id={"model"}
                                    data_testid={"model"}
                                    htmlFor={"model"}
                                    value={deviceSearch?.model}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={30}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='model_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'model_inverse')}
                                        checked={deviceSearch?.model_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceSearch?.model?.trim()===""}
                                    />
                                    <label htmlFor='model_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Serial Number"}
                                    placeholder={"Enter serial number"}
                                    id={"serial_number"}
                                    data_testid={"serial_number"}
                                    htmlFor={"serial_number"}
                                    value={deviceSearch?.serial_number}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={30}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='serial_number_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'serial_number_inverse')}
                                        checked={deviceSearch?.serial_number_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceSearch?.serial_number?.trim()===""}
                                    />
                                    <label htmlFor='serial_number_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"API Identifier"}
                                    placeholder={"Enter API identifier"}
                                    id={"api_identifier"}
                                    data_testid={"api_identifier"}
                                    htmlFor={"api_identifier"}
                                    value={deviceSearch?.api_identifier}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='api_identifier_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'api_identifier_inverse')}
                                        checked={deviceSearch?.api_identifier_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceSearch?.api_identifier?.trim() === ""}
                                    />
                                    <label htmlFor='api_identifier_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Patient ID"}
                                    placeholder={"Enter patient ID"}
                                    id={"patient_id"}
                                    data_testid={"patient_id"}
                                    htmlFor={"patient_id"}
                                    value={deviceSearch.patient_id}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={15}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='patient_id_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'patient_id_inverse')}
                                        checked={deviceSearch.patient_id_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceSearch?.patient_id?.trim()===""}
                                    />
                                    <label htmlFor='patient_id_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <DateInput
                                    initial_reading={false}
                                    labeltext={'Assigned'}
                                    date={{
                                        day: deviceSearch.assigned_day,
                                        month: deviceSearch.assigned_month,
                                        year: deviceSearch.assigned_year,
                                    }}
                                    onDateChange={handleDateChange}
                                    dateFormat={dateFormat}
                                    idPrefix="assigned"

                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='assigned_at_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'assigned_at_inverse')}
                                        checked={deviceSearch.assigned_at_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={
                                            deviceSearch?.assigned_day?.length !== 2 ||
                                        deviceSearch?.assigned_month?.length !== 2 ||
                                        deviceSearch?.assigned_year?.length !== 4 ||
                                        deviceSearch?.assigned_day?.trim() === "" ||
                                        deviceSearch?.assigned_month?.trim() === "" ||
                                        deviceSearch?.assigned_year?.trim() === ""
                                        }
                                    />
                                    <label htmlFor='assigned_at_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {/* purchase date */}
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <DateInputStatic
                                    service_activation={false}
                                    labeltext={'Purchase Date'}
                                    date={{
                                        day: deviceSearch.purchase_date_day,
                                        month: deviceSearch.purchase_date_month,
                                        year: deviceSearch.purchase_date_year,
                                    }}
                                    onDateChange={handleDateChangePurchaseDate}
                                    idPrefix={'Purchase'}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='purchase_date_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'purchase_date_inverse')}
                                        checked={deviceSearch.purchase_date_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={
                                            deviceSearch?.purchase_date_day?.length !== 2 ||
                                        deviceSearch?.purchase_date_month?.length !== 2 ||
                                        deviceSearch?.purchase_date_year?.length !== 4 ||
                                        deviceSearch?.purchase_date_day?.trim() === "" ||
                                        deviceSearch?.purchase_date_month?.trim() === "" ||
                                        deviceSearch?.purchase_date_year?.trim() === ""
                                        }
                                    />
                                    <label htmlFor='purchase_date_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {/* service provider */}
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Service Provider"}
                                    placeholder={"Enter service provider"}
                                    id={"service_provider"}
                                    data_testid={"service_provider"}
                                    htmlFor={"service_provider"}
                                    value={deviceSearch?.service_provider}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='service_provider_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'service_provider_inverse')}
                                        checked={deviceSearch?.service_provider_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceSearch?.service_provider?.trim()===""}
                                    />
                                    <label htmlFor='service_provider_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {/* service period */}
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Service Period"}
                                    placeholder={"Enter service period"}
                                    id={"service_period"}
                                    data_testid={"service_period"}
                                    htmlFor={"service_period"}
                                    value={deviceSearch?.service_period}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='service_period_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'service_period_inverse')}
                                        checked={deviceSearch?.service_period_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceSearch?.service_period?.trim()===""}
                                    />
                                    <label htmlFor='service_period_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {/* service actvation */}
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <DateInputStatic
                                    service_activation={true}
                                    labeltext={'Service Activation'}
                                    date={{
                                        day: deviceSearch.service_activation_date_day,
                                        month: deviceSearch.service_activation_date_month,
                                        year: deviceSearch.service_activation_date_year,
                                    }}
                                    onDateChange={handleDateChangeServiceActivation}
                                    idPrefix={'service'}

                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id=' service_activation_date_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'service_activation_date_inverse')}
                                        checked={deviceSearch.service_activation_date_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={
                                            deviceSearch?.service_activation_date_day?.length !== 2 ||
                                        deviceSearch?.service_activation_date_month?.length !== 2 ||
                                        deviceSearch?.service_activation_date_year?.length !== 4 ||
                                        deviceSearch?.service_activation_date_day?.trim() === "" ||
                                        deviceSearch?.service_activation_date_month?.trim() === "" ||
                                        deviceSearch?.service_activation_date_year?.trim() === ""
                                        }
                                    />
                                    <label htmlFor='service_activation_date_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {/* warranty period */}
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Warranty Period"}
                                    placeholder={"Enter warranty period"}
                                    id={"warranty_period"}
                                    data_testid={"warranty_period"}
                                    htmlFor={"warranty_period"}
                                    value={deviceSearch?. warranty_period}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='warranty_period_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'warranty_period_inverse')}
                                        checked={deviceSearch?.warranty_period_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceSearch?.warranty_period?.trim()===""}
                                    />
                                    <label htmlFor='warranty_period_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <DateInput
                                    initial_reading={true}
                                    labeltext={'Initial Reading'}
                                    date={{
                                        day: deviceSearch.initial_reading_day,
                                        month: deviceSearch.initial_reading_month,
                                        year: deviceSearch.initial_reading_year,
                                    }}
                                    onDateChange={handleDateChangeInitialReading}
                                    dateFormat={dateFormat}
                                    idPrefix="initial_reading"

                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='initial_reading_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'initial_reading_inverse')}
                                        checked={deviceSearch.initial_reading_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={
                                            deviceSearch?.initial_reading_day?.length !== 2 ||
                                        deviceSearch?.initial_reading_month?.length !== 2 ||
                                        deviceSearch?.initial_reading_year?.length !== 4 ||
                                        deviceSearch?.initial_reading_day?.trim() === "" ||
                                        deviceSearch?.initial_reading_month?.trim() === "" ||
                                        deviceSearch?.initial_reading_year?.trim() === ""
                                        }
                                    />
                                    <label htmlFor='initial_reading_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Description"}
                                    placeholder={"Enter description"}
                                    id={"description"}
                                    data_testid={"description"}
                                    htmlFor={"description"}
                                    value={deviceSearch?. description}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={300}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='description_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'description_inverse')}
                                        checked={deviceSearch?.description_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceSearch?.description?.trim()===""}
                                    />
                                    <label htmlFor='description_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                 
                   
                 
                    </div>
                </div>
                <div className='border-t border-[#C5C9DA]'>
                    <section className='mt-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Note:</p>
                        <ol className='list-decimal pl-4 text-xs font-normal text-[#52555D]'>
                            <li>Use a dash (-) to indicate a null value.</li>
                            <li>Use an asterisk (*) as a wild-card character.</li>
                        </ol>
                    </section>
                </div>
                <div className="flex mt-[13px] justify-between">
                    <button 
                        id="Cancel"
                        type='button'
                        onClick={() => handleClearAll()}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault(); // Prevent form submission
                                handleClearAll(); // Perform the clear action
                            }
                        }}
                        className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-sm font-semibold text-[#972E4C] min-w-fit focus:bg-[#edc9d3]" 
                    >Clear All</button>
                    <button  
                        type='submit'
                        id="apply-filter"
                        disabled={isApplyButtonDisabled()}
                        className={`py-2.5 w-[106px] px-4 rounded-[16px]  disabled:bg-[#777C88] bg-[#972E4C] hover:bg-[#AB556E] border border-[#972E4C]'} text-sm font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                        Apply
                    </button>
                </div>
            </form>
        </div>
    )
}
